/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eg_Here_Is_The_Password_ToInputs */

const en_eg_here_is_the_password_to = /** @type {(inputs: Eg_Here_Is_The_Password_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. 'Here is the Google Meet link: https://meet.google.com/...' or 'Download link: ...'`)
};

const es_eg_here_is_the_password_to = /** @type {(inputs: Eg_Here_Is_The_Password_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. 'Aquí tienes la contraseña para la reunión de Zoom: 12345'`)
};

const fr_eg_here_is_the_password_to = /** @type {(inputs: Eg_Here_Is_The_Password_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. 'Voici le mot de passe pour la réunion Zoom : 12345'`)
};

const de_eg_here_is_the_password_to = /** @type {(inputs: Eg_Here_Is_The_Password_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. 'Hier ist das Passwort für das Zoom-Meeting: 12345'`)
};

const ja_eg_here_is_the_password_to = /** @type {(inputs: Eg_Here_Is_The_Password_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: 'Zoomミーティングのパスワードはこちらです: 12345'`)
};

const zh_eg_here_is_the_password_to = /** @type {(inputs: Eg_Here_Is_The_Password_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：'这是 Zoom 会议的密码：12345'`)
};

const ar_eg_here_is_the_password_to = /** @type {(inputs: Eg_Here_Is_The_Password_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مثال: 'إليك كلمة المرور لاجتماع زووم: 12345'`)
};

const id_eg_here_is_the_password_to = /** @type {(inputs: Eg_Here_Is_The_Password_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. 'Berikut adalah tautan Google Meet: https://meet.google.com/...' atau 'Tautan unduh: ...'`)
};

const it_eg_here_is_the_password_to = /** @type {(inputs: Eg_Here_Is_The_Password_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. 'Ecco la password per il meeting Zoom: 12345'`)
};

const ru_eg_here_is_the_password_to = /** @type {(inputs: Eg_Here_Is_The_Password_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`например, 'Вот пароль от конференции Zoom: 12345'`)
};

const pt_eg_here_is_the_password_to = /** @type {(inputs: Eg_Here_Is_The_Password_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. 'Aqui está a senha para a reunião no Zoom: 12345'`)
};

const ko_eg_here_is_the_password_to = /** @type {(inputs: Eg_Here_Is_The_Password_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예: 'Zoom 미팅 비밀번호는 다음과 같습니다: 12345'`)
};

/**
* | output |
* | --- |
* | "e.g. 'Here is the Google Meet link: https://meet.google.com/...' or 'Download link: ...'" |
*
* @param {Eg_Here_Is_The_Password_ToInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const eg_here_is_the_password_to = /** @type {((inputs?: Eg_Here_Is_The_Password_ToInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eg_Here_Is_The_Password_ToInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eg_here_is_the_password_to(inputs)
	if (locale === "es") return es_eg_here_is_the_password_to(inputs)
	if (locale === "fr") return fr_eg_here_is_the_password_to(inputs)
	if (locale === "de") return de_eg_here_is_the_password_to(inputs)
	if (locale === "ja") return ja_eg_here_is_the_password_to(inputs)
	if (locale === "zh") return zh_eg_here_is_the_password_to(inputs)
	if (locale === "ar") return ar_eg_here_is_the_password_to(inputs)
	if (locale === "id") return id_eg_here_is_the_password_to(inputs)
	if (locale === "it") return it_eg_here_is_the_password_to(inputs)
	if (locale === "ru") return ru_eg_here_is_the_password_to(inputs)
	if (locale === "pt") return pt_eg_here_is_the_password_to(inputs)
	return ko_eg_here_is_the_password_to(inputs)
});